import React, { useRef, useEffect, useState } from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Fab from "@mui/material/Fab";

import CreateEditSalesman from "./CreateEditSalesman";
import LinearProgress from "@mui/material/LinearProgress";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import CreateSalesmanTargetViaCSVDialog from "./CreateSalesmanTargetViaCSV";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import { InputAdornment } from "@material-ui/core";
import Grid from "@mui/material/Grid";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    backgroundColor: "#ffffff",
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  grow: {
    flexGrow: 1,
  },
  iconMargin: {
    margin: "0 0 0 15px",
  },
  yellowButton: {
    backgroundColor: "#ffff00",
    color: "black",
    "&:hover": {
      backgroundColor: "#ffff00",
    },
  },
}));
const filter = createFilterOptions();

function Salesmans(props) {
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState(null);
  const accountsElement = useRef();
  const [openCreateEditSalesman, setOpenCreateEditSalesman] = useState(false);
  const [salesmans, setSalesman] = useState([]);
  const [selectedSalesman, setSelectedSalesman] = useState();
  const [salesmanAction, setSalesmanAction] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [, setMenuAnchorEl] = useState(null);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [showStatusDialog, setShowStatuDialog] = useState(false);
  const [StatusDialogMessage, setStatusDialogMessage] = useState("");
  const [salesmanStatus, setSalesmanStatus] = useState({});

  const [isDoingAction, setIsDoingAction] = useState(false);
  const [showCreateSalesmanTargetViaCSV, setShowCreateSalesmanTargetViaCSV] = useState(false);
  const [openEditTargetMenu, setOpenEditTargetMenu] = useState(false);
  const [targetInputValues, setTargetInputValues] = useState([]);

  const [editSalesman, setEditSalesman] = useState("");
  const [salesmanTarget, setSalesmanTarget] = useState([]);

  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [updateMessage, setUpdateMessage] = useState("");

  const [searchSalesmanTerm, setSearchSalesmanTerm] = useState({ name: "" });
  const [loadSalesman, setLoadSalesman] = useState(true);
  const [autoSuggestSalesman, setAutoSuggestSalesman] = useState([]);

  const menuHandleClose = () => {
    setMenuAnchorEl(null);
    setShowStatuDialog(false);
    setShowMessageDialog(false);
  };

  function reloadSalesmans() {
    loadAccounts();
  }

  useEffect(() => {
    loadAccounts();
  }, []);

  function loadAccounts() {
    setIsLoading(true);

    const options = {
      method: "POST",
      url: "/TransactiSalesman/getTransactiSellerUsers.json",
      data: objectToFormData({ search_term: "" }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);

        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");
          return;
        }

        setSalesman(res.data.response.Salesmans);
      })
      .catch((error) => {
        setIsLoading(false);
        // setIsSavingSuccess(false)
        alert("Error encounter");
        console.log(error);
      });
  }

  useEffect(() => {
    function fetchAutoSuggesSalmesman(searchString) {
      const loadSalesman = async () => {
        const options = {
          method: "POST",
          url: "/TransactiSalesman/getSalesmanForAutoSuggest.json",
          data: objectToFormData({ search_term: searchString }),
        };
        await axios(options).then((res) => {
          const accounts = res.data.response.Salesmans;
          if (accounts.length <= 0) {
            setAutoSuggestSalesman([]);
          } else {
            setAutoSuggestSalesman(accounts);
          }
        });
      };
      loadSalesman();
    }

    if (searchSalesmanTerm == null) {
      fetchAutoSuggesSalmesman("");
    } else {
      fetchAutoSuggesSalmesman(searchSalesmanTerm.name);
    }
  }, [searchSalesmanTerm]);

  useEffect(() => {
    if (!loadSalesman) {
      return;
    }
    fetchSalesman(searchSalesmanTerm.name);
  }, [loadSalesman, searchSalesmanTerm]);

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);

      return formData;
    }, new FormData());

  function autoComplete() {
    return (
      <Autocomplete
        value={searchSalesmanTerm}
        noOptionsText="No records found."
        onChange={(event, newValue) => {
          if (newValue === null || newValue.name === "") {
            searchSalesmanTerm.name = "";
            return;
          }
          searchSalesmanTerm.name = newValue.name;
          setSalesman([]);
          setLoadSalesman(true);
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestSalesman}
        isOptionEqualToValue={() => true}
        getOptionLabel={(option) => {
          return option.name;
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.name}>
              {option.name}
            </li>
          );
        }}
        style={{ width: "100%", paddingLeft: "8px" }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event) => {
              setSearchSalesmanTerm({ name: event.target.value });
            }}
          />
        )}
      />
    );
  }

  function search() {
    return (
      <div
        position="static"
        style={{ border: ".1rem solid #989898", borderRadius: "4px", margin: "2px" }}
      >
        <Toolbar variant="dense" style={{ padding: "0" }}>
          <Box flexGrow={1}>{autoComplete()}</Box>
          <Box>
            <IconButton
              className={classes.margin}
              size="large"
              onClick={() => {
                setSalesman([]);
                setLoadSalesman(true);
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </div>
    );
  }

  function fetchSalesman(searchValue) {
    setIsLoading(true);
    const options = {
      method: "POST",
      url: "/TransactiSalesman/getFetchSalesman.json",
      data: objectToFormData({ search_term: searchValue }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        setLoadSalesman(false);

        const isSuccess = res.data.response.is_success;

        if (!isSuccess) {
          alert("Error encounter");
          return;
        }
        setSalesman(res.data.response.Salesmans);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  function salesmanElement(salesman) {
    return (
      <div>
        <Typography variant="h6" gutterBottom>
          {salesman.first_name} {salesman.last_name}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {salesman.username}
        </Typography>
        <Typography variant="body1" gutterBottom>
          {salesman.mobile_number}
        </Typography>
        <div>
          <Typography variant="h7" sx={{ color: "black" }} gutterBottom>
            Current Month Target:&nbsp;
          </Typography>
          <Typography variant="h7" sx={{ color: "green" }} gutterBottom>
            ₱
            {Number(salesman.monthly_target).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </div>
      </div>
    );
  }

  useEffect(() => {
    if (Object.keys(salesmanStatus).length === 0) {
      return;
    }
  }, [salesmanStatus]);

  function handleSalesmanStatusBtn(salesman, status) {
    menuHandleClose();
    setShowStatuDialog(true);
    setStatusDialogMessage(
      "Are you sure you want to set salesman " +
        salesman.first_name +
        " " +
        salesman.last_name +
        " as " +
        status +
        "?"
    );
    setSalesmanStatus(salesman);
  }

  // const handleEditTarget = async (salesman) => {
  //   const options = {
  //     method: 'POST',
  //     url: '/TransactiSalesman/getSalesmanTarget.json',
  //     data:objectToFormData({salesman:salesman.username})
  //   }

  //   const response = await axios(options)
  //   const resTarget = response.data.result;
  //   const sortedTargets = Object.keys(resTarget).map((date) => ({
  //     date,
  //     value: resTarget[date],
  //   }));

  //   setSalesmanTarget(sortedTargets);
  //   setTargetInputValues(sortedTargets);
  //   setEditSalesman(salesman.username);
  //   setOpenEditTargetMenu(true);
  // }

  const updateSalesman = async () => {
    setShowStatuDialog(false);
    setIsDoingAction(true);
    setMessageDialogMessage("Updating... Please wait...");

    const options = {
      method: "POST",
      url: "/TransactiSalesman/updateSalesmanStatus.json",
      data: objectToFormData({
        username: salesmanStatus.username,
        id: salesmanStatus.id,
        status: salesmanStatus.active,
      }),
    };

    const response = await axios(options);
    const is_success = response.data.response.is_success;
    const message = response.data.response.message;

    setIsDoingAction(false);
    menuHandleClose();
    setShowMessageDialog(true);
    setMessageDialogMessage(message);

    if (is_success) {
      setSalesman([]);
      reloadSalesmans();
    }
  };

  function progressDialog() {
    return (
      <Dialog fullWidth={true} maxWidth={"lg"} open={isDoingAction} onClose={() => {}}>
        <DialogContent>
          <DialogContentText>{messageDialogMessage}</DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  }

  const statusDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showStatusDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Update Salesman"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{StatusDialogMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              updateSalesman();
            }}
            autoFocus
          >
            {" "}
            <Typography color="success">Confirm</Typography>
          </Button>
          <Button
            onClick={() => {
              setShowStatuDialog(false);
            }}
            color="primary"
            autoFocus
          >
            <Typography color="primary">Cancel</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const messageDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const EditTargetDialog = () => {
    return (
      <Dialog maxWidth="md" fullWidth open={openEditTargetMenu}>
        <DialogTitle>Edit Sales Target {editSalesman ? `(${editSalesman})` : ""}</DialogTitle>
        <DialogContent sx={{ m: 1 }}>
          <Grid container spacing={2} sx={{ mt: "1px" }}>
            {salesmanTarget.map((value, index) => (
              <Grid item md={6} key={index}>
                <TextField
                  fullWidth
                  label={value.date}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₱</InputAdornment>,
                  }}
                  defaultValue={value.value}
                  onChange={(e) => handleOnChangeValues(value.date, e.target.value)}
                />
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" className={classes.yellowButton} onClick={handleUpdateClick}>
            Update
          </Button>
          <Button
            variant="contained"
            className={classes.yellowButton}
            onClick={handleEditDialogClick}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleEditDialogClick = () => {
    setMenuAnchorEl(null);
    openEditTargetMenu ? setOpenEditTargetMenu(false) : setOpenEditTargetMenu(true);
  };

  const handleUpdateClick = async () => {
    const options = {
      method: "POST",
      url: "/TransactiSalesman/updateSellerTargets.json",
      data: objectToFormData({
        salesman: editSalesman,
        targets: JSON.stringify(targetInputValues),
      }),
    };

    await axios(options).then(function (res) {
      setOpenConfirmationDialog(true);
      setUpdateMessage(res.data.message);
      handleEditDialogClick();
    });
    setIsLoading(false);
    setSalesman([]);
    reloadSalesmans();
  };

  const confirmationDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="confirmation-dialog-title"
        open={openConfirmationDialog}
      >
        <DialogTitle id="confirmation-dialog-title">Sales Target Update</DialogTitle>
        <DialogContent>{updateMessage}</DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              setOpenConfirmationDialog(false);
            }}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleOnChangeValues = (date, value) => {
    if (!isNaN(parseFloat(value))) {
      const decimalRegex = /^\d{1,18}(\.\d{1,2})?$/;
      if (decimalRegex.test(value)) {
        const inputIndex = targetInputValues.findIndex((entry) => entry.date === date);
        if (inputIndex !== -1) {
          setTargetInputValues((prevValues) => {
            const updatedValues = [...prevValues];
            value = parseFloat(value);
            updatedValues[inputIndex] = { date, value };
            return updatedValues;
          });
        }
      }
    }
  };

  useEffect(() => {}, [salesmanAction, selectedSalesman]);

  return (
    <div>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={props.handleDrawerToggle}
            className={classes.menuButton}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            Salesmen
          </Typography>
        </Toolbar>
      </AppBar>
      {search()}
      {isLoading ? (
        <LinearProgress color="secondary" style={{ marginLeft: ".1rem", marginRight: ".1rem" }} />
      ) : (
        ""
      )}
      <List ref={accountsElement}>
        {salesmans.map((salesman, index) => {
          return (
            <div key={salesman.id}>
              <ListItem button>
                {salesmanElement(salesman)}

                <div className={classes.grow} />

                <EditIcon
                  className={classes.iconMargin}
                  onClick={() => {
                    setSelectedSalesman(salesman);
                    menuHandleClose();
                    setSalesmanAction("update");
                    setOpenCreateEditSalesman(true);
                  }}
                />

                {/* <CrisisAlertIcon 
                          className={classes.iconMargin}
                          onClick={() => handleEditTarget(salesman)}
                        />  */}
                {salesman.active === 1 ? (
                  <Button
                    className={classes.iconMargin}
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => handleSalesmanStatusBtn(salesman, "inactive")}
                  >
                    ✔ Active
                  </Button>
                ) : (
                  <Button
                    className={classes.iconMargin}
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleSalesmanStatusBtn(salesman, "active")}
                  >
                    ✖ Inactive
                  </Button>
                )}
              </ListItem>
              <Divider />
            </div>
          );
        })}
      </List>
      <AppBar
        position="fixed"
        style={{ background: "transparent", boxShadow: "none" }}
        className={classes.appBarBottom}
      >
        <Toolbar>
          <div className={classes.grow} />

          <Fab
            variant="extended"
            size="medium"
            color="primary"
            aria-label="add"
            className={classes.margin}
            sx={{ mr: "5px" }}
            onClick={() => {
              setSalesmanAction("add");
              setOpenCreateEditSalesman(true);
            }}
          >
            <AddIcon className={classes.extendedIcon} />
            Add salesman
          </Fab>

          {/* <Fab
                  variant="extended"
                  size="medium"
                  color="primary"
                  aria-label="add"
                  className={classes.margin}
                  onClick={()=>{
                    setShowCreateSalesmanTargetViaCSV(true)
                  }}
                ><AddIcon className={classes.extendedIcon} />
                  Upload Targets
                </Fab> */}
        </Toolbar>
      </AppBar>
      {openCreateEditSalesman ? (
        <CreateEditSalesman
          reloadSalesmans={reloadSalesmans}
          selectedSalesman={selectedSalesman}
          setSelectedSalesman={setSelectedSalesman}
          setSalesmanAction={setSalesmanAction}
          salesmanAction={salesmanAction}
          openCreateEditSalesman={openCreateEditSalesman}
          setOpenCreateEditSalesman={setOpenCreateEditSalesman}
        />
      ) : (
        ""
      )}

      {showCreateSalesmanTargetViaCSV ? (
        <CreateSalesmanTargetViaCSVDialog
          salesmen={salesmans}
          showCreateSalesmanTargetViaCSV={showCreateSalesmanTargetViaCSV}
          setShowCreateSalesmanTargetViaCSV={setShowCreateSalesmanTargetViaCSV}
        />
      ) : (
        ""
      )}

      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {statusDialog()}
          {progressDialog()}
          {messageDialog()}
          {EditTargetDialog()}
          {confirmationDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default Salesmans;
